import React from 'react';
import './style.scss';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { Snack, SodaCan } from '../../../atoms/icons';

export interface BadgeProps {
    id: string;
    label: string;
    iconType: 'soda' | 'snack'
    onClick?: React.MouseEventHandler<SVGSVGElement> | undefined
    className?: string | undefined;
    isCancel? :boolean;
  }

const Badge: React.FC<BadgeProps> = (props) => {
  const {
    id, label, iconType, onClick, className, isCancel = true,
  } = props;
  return (
    <div id={id} className={`card-badge-container ${className}`}>
      <div style={{ marginBottom: '2px', marginRight: '5px' }}>
        {iconType === 'soda' ? <SodaCan width={8} /> : <Snack width={10} />}
      </div>
      <label htmlFor={id}>{label}</label>
      <CancelRoundedIcon
        role="button"
        onClick={onClick}
        className={isCancel ? 'color-primary fz-20 ms-2' : 'd-none'}
      />
    </div>
  );
};

export default Badge;
